const amazonLink = (href, tag = null) => {
  // Override tag if one exists
  if (tag) href = href.replace(/(tag=)[^\&]+/, "$1" + tag);

  return href;
};

export default amazonLink;
